// ── État du module suggestions ────────────────────────────────────────────────

/** Dernier tableau de suggestions reçu de l'API (conservé pour le bouton "+"). */
export let dernièresSuggestions = [];

/** Nombre de suggestions affichées par tranche. */
export const SUGGESTIONS_PAS = 3;

/** Nombre maximal de suggestions affichables. */
export const SUGGESTIONS_MAX = 15;

/**
 * Remplace la référence aux dernières suggestions.
 * @param {Array} suggestions  tableau retourné par l'API
 */
export function setDernièresSuggestions(suggestions) {
    dernièresSuggestions = suggestions;
}
